<!--
 * @Description: 浏览分布区域热力图，多个地方公用修改时需要注意
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div>
      <span class="bi-tmpl-detail__right__cmpt__title">
        {{ curItem.title }}
      </span>
      <span v-if="curItem.tips" class="bi-tmpl-detail__right__cmpt__tips">
        {{ curItem.tips }}
      </span>
    </div>

    <div
      style="
        box-sizing: border-box;
        padding: 54px 5px;
        display: flex;
        justify-content: center;
        border: solid 1px #e5e5e5;
        border-radius: 2px;
      "
    >
      <PcModuleMap></PcModuleMap>
    </div>

    <span class="bi-tmpl-detail__right__cmpt__title">请选择表格样式</span>
    <Carousel ref="carouselRef" :itemHeight="120" :itemWidth="795 + 56">
      <div
        style="height: 120px; width: 100%"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
        @click="onChange(item.value)"
      >
        <BaseCard style="width: 795px; height: 120px">
          <component
            :is="cmpName(item.moduleType)"
            style="width: 1500px; transform: scale(0.5); transform-origin: 0 0"
            v-bind="{
              tableHeaderList: tableHeaderList,
              tableDataList: tableDataList
            }"
          />
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            :value="item.value"
            :model-value="curItem.value"
          ></BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import _ from 'lodash';
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { Carousel } from '@/components/base/carousel';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import PcModuleMap from '@/views/bi-tmpl/src/components/bi-pc-module/pc-module-map.vue';
import PcModuleTable from '@/views/bi-tmpl/src/components/bi-pc-module/pc-module-table/index';

const TYPE_MAPPING = PcModuleTable.reduce((pre, cur, i) => {
  const cName = cur.__name;
  pre[cName] = {
    cmpt: cur,
    value: 'pc-module-table-' + (i + 1),
    moduleType: cName
  };
  return pre;
}, {});

const tableHeaderList = ref([
  { prop: 'province', label: ['省份'] },
  { prop: 'zj', label: ['浙江'] },
  { prop: 'hb', label: ['湖北'] },
  { prop: 'bj', label: ['北京'] },
  { prop: 'sx', label: ['陕西'] },
  { prop: 'jl', label: ['吉林'] },
  { prop: 'sc', label: ['四川'] },
  { prop: 'other', label: ['其他'] }
]);
const tableDataList = ref([
  {
    province: ['有效点击率'],
    zj: ['186'],
    hb: ['99'],
    bj: ['99'],
    sx: ['86'],
    jl: ['77'],
    sc: ['49'],
    other: ['48']
  }
]);

const cmpName = name => {
  return PcModuleTable.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange } = useDetailCmpt();
</script>
<style scoped lang="scss">
::v-deep {
  .xrk-radio__input {
    bottom: 110px !important;
  }
}
</style>
